import Markdown from 'markdown-to-jsx';
import Image from 'next/image';
import classes from './GettingStartedSteps.module.scss';

export default function GettingStartedSteps(props) {
    if (!props) return null;
    const steps = props.data;
    return (
        <div className={classes.oThreeStepSectionBlock}>
            {steps.map((step) => (
                <div
                    key={step.id}
                    className={`${classes.oStepBlock} ${classes[`step${step.step_order}`]} ${
                        classes[`imageLeft_${step.image_on_left.toString()}`]
                    }`}
                >
                    <div className={`${classes.oContainer} container`}>
                        <div className={`row`}>
                            <div className={`${classes.oBlockImage} col-12 col-md-6`}>
                                <figure className={classes.mImage}>
                                    <Image
                                        src={step?.image?.data?.attributes?.url}
                                        alt={step?.image?.data?.attributes?.title}
                                        width={step?.image?.data?.attributes?.width}
                                        height={step?.image?.data?.attributes?.height}
                                        className={classes.aImage}
                                        aria-hidden="true"
                                        layout="responsive"
                                    />
                                </figure>
                            </div>

                            <div className={`${classes.oBlockText} col-12 col-md-6`}>
                                <div className={classes.mStepTitle}>
                                    <figure className={classes.mGettingStartedIcon}>
                                        <Image
                                            src={step?.icon?.data?.attributes?.url}
                                            alt="icon"
                                            width={24}
                                            height={24}
                                            className={classes.aImage}
                                            layout="fixed"
                                        />
                                    </figure>
                                    <h3 className={`${classes.aTitle} fnt30`}>{step.title}</h3>
                                </div>
                                <Markdown className={`${classes.mText} fnt18f fnt-pm fontRTL`}>
                                    {step.copy}
                                </Markdown>
                            </div>
                        </div>
                    </div>

                    <figure
                        className={`${classes.mCardBackground} ${
                            classes[`step${step.step_order}`]
                        }`}
                    >
                        <Image
                            src={step?.background_image?.data?.attributes?.url}
                            alt={step?.background_image?.data?.attributes?.title}
                            width={step?.background_image?.data?.attributes?.width}
                            height={step?.background_image?.data?.attributes?.height}
                            className={classes.aImage}
                            aria-hidden="true"
                            layout="responsive"
                        />
                    </figure>
                </div>
            ))}
        </div>
    );
}
